module.exports = __webpack_public_path__ + "static/media/pic6.3a703a82.jpg";